var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "trendChart c3-custom-chart",
    attrs: { id: _vm.chartId }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }